import { render, staticRenderFns } from "./RoomBackButton.vue?vue&type=template&id=4ec05140&scoped=true"
import script from "./RoomBackButton.vue?vue&type=script&lang=js"
export * from "./RoomBackButton.vue?vue&type=script&lang=js"
import style0 from "./RoomBackButton.vue?vue&type=style&index=0&id=4ec05140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec05140",
  null
  
)

export default component.exports